import React from 'react';
import { ChannelSubscriptionBase } from '../../../payments/channel-subscription';
import styles from './account-subscription.scss';

export const AccountSubscription = (props) => (
  <ChannelSubscriptionBase {...props} styles={styles} />
);
